/**
 * Push a GA4 `select_item` event to the dataLayer.
 *
 * @param {object} product - Product as returned by `/api/products/batch/`
 * @param {string} itemListId - GA4 item_list_id, e.g. 'campaign_products'
 * @param {string} itemListName - GA4 item_list_name, e.g. 'Campaign Products'
 */
export default function selectItem(product, itemListId, itemListName) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: itemListId || '',
        item_list_name: itemListName || '',
        currency: product?.prices?.currency || 'N/A',
        items: [
          {
            item_id: product?.id || '',
            item_name: product?.name || '',
            item_brand: product?.attributes?.brand || '',
            item_category: product?.attributes?.item_type || '',
            item_list_name: itemListName || '',
            item_list_id: itemListId || '',
            item_variant: product?.style || '',
            price: Number(product?.prices?.min_price) || 0,
            quantity: 1
          }
        ]
      }
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}
